import { brand } from "@/config/brand";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  { label: "How It Works", id: "how" },
  { label: "AI Agents", id: "agents" },
  { label: "Pricing", id: "pricing" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  return (
    <footer className="bg-black pb-10 pt-20 text-white">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 border-b border-white/10 pb-14 md:grid-cols-[1.4fr_1fr]">
          <div>
            <img
              src={brand.logo_url}
              alt={brand.brand_name}
              className="h-10 w-auto object-contain"
              style={{ maxWidth: 200 }}
            />
            <p className="mt-6 max-w-sm text-base font-light leading-relaxed text-white/50">
              The intelligent platform helping local businesses collect reviews, grow
              visibility, and build trust — automatically.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">Explore</span>
            <div className="grid grid-cols-2 gap-3">
              {NAV.map((n) => (
                <button
                  key={n.id}
                  data-testid={`footer-nav-link-${n.id}`}
                  onClick={() => scrollToId(n.id)}
                  className="text-left text-sm font-light text-white/70 transition-colors hover:text-white"
                >
                  {n.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-3 pt-8 text-xs font-light text-white/40 sm:flex-row sm:items-center">
          <span>© {new Date().getFullYear()} {brand.brand_name}. All rights reserved.</span>
          <span>Built for modern local businesses.</span>
        </div>
      </div>
    </footer>
  );
}
